import React, { useState, useEffect, useCallback } from 'react';
import { I18n } from 'aws-amplify';
import { Link } from 'react-router-dom';

import findLocalStorage from '../util/findLocalStorage.js'
import {
  ENERGYMNTR_URL,
  GRAND_ARCH_URL,
  PPMS_URL,
  TERM_VER,
  HEADER_VIEW_PATTERN
} from "../../configures/val.js";
import { authConfig } from "../../configures/awsConfig.js";

import authCheck, {getPpaSid, getCanISeePpms} from '../util/callApi.js';
import checkTermsVer from '../util/checkTermsVer.js';
import LapDialog from '../util/laplaceDialog.js';
import PpmsServiceItem from './ppms/ppmsServiceItem.js';

function ServiceList(props) {
  const [isHighlight, setHighlight] = useState(false);
  const [termError, setTermError] = useState(false);
  const [hrefAfterTermConfirm, setHrefAfterTermConfirm] = useState('');
  const [isPpaProvider, setIsPpaProvider] = useState(false);
  const [hasPpmsPerm, setHasPpmsPerm] = useState(false);

  // ヘッダハイライト
  useEffect(() => {
    if (!isHighlight) {
      props.updateHeader('serviceList');
      props.updateTabPattern(HEADER_VIEW_PATTERN.DEFAULT);
      setHighlight(true);
    }
  }, [props, isHighlight])
  // 認証ステータスと利用規約のバージョンを確認
  const confirmUserStatus = useCallback(async() => {
    const authRet = await authCheck();
    if (authRet.result === 'NG') {
      props.authStateChange('signIn');
      return true;
    }
    const isLowVer = checkTermsVer(authRet.data, 'custom:agreed_term', TERM_VER, 'ver');
    if (isLowVer) {
      setTermError(true);
      return true;
    }
    return false;
  }, [props]);
  useEffect(() => {
    confirmUserStatus();
  }, [confirmUserStatus]);
  // 認可DB呼び出し
  useEffect(() => {
    async function callGetPpaSid() {
      const ret = await getPpaSid();
      if (verifyResponse(ret.data)) {
        setIsPpaProvider(true);
      }
    }
    callGetPpaSid();
  }, [isPpaProvider]);
  const verifyResponse = (arg) => {
    if (!arg.hasOwnProperty('supplier_ids')) {
      return false;
    }
    if (arg.supplier_ids.length <= 0) {
      return false;
    }
    return true;
  }
  useEffect(() => {
    async function callGetCanISeePpms() {
      const bCanISeePpms = await getCanISeePpms();
      if (bCanISeePpms) {
        setHasPpmsPerm(true);
      }
    }
    callGetCanISeePpms();
  }, [hasPpmsPerm]);
  const handleHref = async (e, href) => {
    e.preventDefault();
    if (href) {
      setHrefAfterTermConfirm(href);
    }
    if (await confirmUserStatus()) {
      return;
    }
    window.location.href = href;
  }
  const closeDialog = () => {
    const authProp = {
      href: hrefAfterTermConfirm
    };
    props.authStateChange('reagreeTermsDocs', authProp);
  }
  const updateHeaderAsPpa = () => {
    props.updateHeader('ppaProductlist');
    props.updateTabPattern(HEADER_VIEW_PATTERN.PPA);
  }
  const destinationSitelist = ENERGYMNTR_URL+"sitelist";
  const refreshToken = findLocalStorage('refreshToken');
  const destinationGrandArch = GRAND_ARCH_URL + "login_get?refresh_token=" + refreshToken + "&client_id=" + authConfig.userPoolWebClientId;
  const destinationPpms = PPMS_URL + "login_get?refresh_token=" + refreshToken + "&client_id=" + authConfig.userPoolWebClientId;
  const showPpaUserViewManage = () => {
    return(
      <div className="serviceItem">
        <div className="serviceItemInner">
          <h2><span className="mypageTitleIcon"></span>{I18n.get('User Screen Management')}</h2>
          <p>{I18n.get('It is possible to check the list of power plants and set the user screen.')}</p>
          <Link to='/ppa/productlist' className="menuButton blue" onClick={updateHeaderAsPpa}>{I18n.get('Open')}</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="mypageContainer">
      <p className="mypageDescription">{I18n.get('The Laplace ID allows you to take advantage of a variety of services.')}</p>
      <div className="serviceFlexArea">
        { !hasPpmsPerm 
          ? <div className="serviceItem">
              <div className="serviceItemInner">
                <h2><span className="mypageTitleIcon"></span>{I18n.get('Plant management')}</h2>
                <p>{I18n.get('This is the screen to link and manage power plants that have Laplace ID and L eye monitoring screen.')}</p>
                <a className="menuButton blue" href={destinationSitelist} onClick={(e) => {handleHref(e, destinationSitelist)}}>{I18n.get('Open')}</a>
              </div>
            </div>
          : ""
        }
        <div className="serviceItem">
          <div className="serviceItemInner">
            <h2><span className="mypageTitleIcon"></span>{I18n.get('Integrated monitoring')}</h2>
            <p>{I18n.get('It is possible to manage the status and information of multiple power plants in one place.')}</p>
            <a className="menuButton blue" href={destinationGrandArch} onClick={(e) => {handleHref(e, destinationGrandArch)}}>{I18n.get('Open')}</a>
          </div>
        </div>
        <div className="serviceItem">
          <div className="serviceItemInner">
            <h2><span className="mypageTitleIcon"></span>{I18n.get('Mieruka Web')}</h2>
            <p>{I18n.get('It is possible to create PR content that can be viewed on the web using measurement data from power plants.')}</p>
            <Link to='/mierukamanage' className="menuButton blue">{I18n.get('Open')}</Link>
          </div>
        </div>
        {isPpaProvider ? showPpaUserViewManage() : '' }
        {hasPpmsPerm ? <PpmsServiceItem url={destinationPpms} onClick={(e) => {handleHref(e, destinationPpms)}} /> : '' }
      </div>
      <LapDialog
        title={''}
        contentElem={
          <div>
          <p>{I18n.get('Terms of Service is updated.')}</p>
          <p>{I18n.get('Please reconfirm it.')}</p>
          </div>
        }
        firstButtonText={'OK'}
        firstButtonFunc={() => closeDialog()}
        open={termError}
        toClose={() => {return;}}
      />
    </div>
  );
}
export default ServiceList;
